import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';

export type FdkInitialsSize = 'small' | 'large';

@Component({
  selector: 'fdk-initials',
  templateUrl: './initials.component.html',
  styleUrl: './initials.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FdkInitialsComponent {
  @Input() initials = '';
  @Input() size: FdkInitialsSize = 'small';

  get displayedInitials(): string {
    return this.initials.slice(0, 2).toUpperCase();
  }
}
